import { render, staticRenderFns } from "./AddArtistWizardStepAddArtist.vue?vue&type=template&id=f6868c1c&scoped=true&"
import script from "./AddArtistWizardStepAddArtist.vue?vue&type=script&lang=js&"
export * from "./AddArtistWizardStepAddArtist.vue?vue&type=script&lang=js&"
import style0 from "./AddArtistWizardStepAddArtist.vue?vue&type=style&index=0&id=f6868c1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6868c1c",
  null
  
)

export default component.exports